export const isEmbedSearch = (search) => {
    try {
        return new URLSearchParams(search || '').get('embed') === '1';
    } catch (_) {
        return false;
    }
};
